import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Select from "react-select";

import close from "../static/img/ic-close.svg";
import "../static/scss/sureAlert.scss";

export const SureAlert = (props) => {
    const { title, type, text, handleSubmit, handleClose, submitText } = props;
    const { t } = useTranslation("alert");
    const { availablePsychs, user } = useSelector((state) => state.auth);
    const [selectedPsych, setSelectedPsych] = useState(null);
    const [message, setMessage] = useState("");
    // Проверяем, нужен ли выбор психолога
    const needPsychSelection = type === "wantTalk" && availablePsychs.length > 1;

    useEffect(() => {
        if (type === "wantTalk" && availablePsychs.length > 0) {
            // Всегда выбираем главного психолога по умолчанию
            const ownerPsych = availablePsychs.find((p) => p.isOwner);
            if (ownerPsych) {
                setSelectedPsych(ownerPsych);
            } else if (availablePsychs.length === 1) {
                setSelectedPsych(availablePsychs[0]);
            }
        }
    }, [type, availablePsychs]);

    const handleSubmitWithPsych = () => {
        // Определяем ID психолога для отправки
        let psychId;

        if (type === "wantTalk") {
            if (selectedPsych) {
                // Если психолог выбран, используем его ID
                psychId = selectedPsych._id;
            } else if (availablePsychs.length === 1) {
                // Если психолог один, используем его ID
                psychId = availablePsychs[0]._id;
            } else {
                // Если психолог не выбран и их несколько, не отправляем
                return;
            }
        }
        
        handleSubmit(psychId || user?.psych, message);
    };

    const psychOptions = availablePsychs.map((psych) => ({
        value: psych._id,
        label: psych.name,
        data: psych,
    }));

    const selectStyles = {
        control: (base) => ({
            ...base,
            marginBottom: "20px",
            borderColor: "#8B5CF6",
            "&:hover": {
                borderColor: "#8B5CF6",
            },
        }),
    };

    return (
        <div className="sureAlert">
            <div className={`sureAlert__inner ${type === "wantTalk" ? "wide" : ""}`}>
                <h3>{title || t("alert_title")}</h3>

                {type === "createTest" && (
                    <p>
                        {t("create_test")}
                        <br />
                        <br />
                        {t("cancel_action")}
                    </p>
                )}

                {type === "createMeeting" && <p>{t("create_meeting")}</p>}

                {type === "createNote" && <p>{t("create_note")}</p>}

                {type === "createAdvice" && <p>{t("create_recommendation")}</p>}

                {type === "wantTalk" && (
                    <>
                        <p>
                            {t("want_to_talk_1")}
                            <br />
                            <br />
                            {t("want_to_talk_2")}
                        </p>

                        {needPsychSelection && (
                            <div style={{ textAlign: 'left', width: "100%", padding: "0 20px" }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#666' }}>
                                    {t("your_psych")}
                                </label>
                                <Select
                                    options={psychOptions}
                                    value={psychOptions.find((opt) => opt.value === selectedPsych?._id)}
                                    onChange={(option) => setSelectedPsych(option.data)}
                                    placeholder={t("select_psych_placeholder")}
                                    styles={selectStyles}
                                    isSearchable={false}
                                />
                            </div>
                        )}
                        
                        <div style={{ textAlign: 'left', width: "100%", padding: "0 20px" }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#666' }}>
                                {t("message_for_psych")}
                            </label>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value.substring(0, 300))}
                                placeholder={t("message_placeholder")}
                                maxLength={300}
                                style={{
                                    width: '100%',
                                    minHeight: '80px',
                                    maxHeight: "170px",
                                    padding: '10px',
                                    paddingRight: '6px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    resize: 'none',
                                    outline: 'none',
                                    transition: 'border-color 0.2s',
                                    boxSizing: 'border-box',
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#8B5CF6'}
                                onBlur={(e) => e.target.style.borderColor = '#ddd'}
                            />
                            <div style={{ fontSize: '12px', color: '#999', marginTop: '4px', textAlign: 'right' }}>
                                {message.length}/300
                            </div>
                        </div>
                    </>
                )}

                {type === "moveToArchive" && <p>{t("move_to_archive")}</p>}

                {type === "deletePupil" && <p>{t("delete_pupil")}</p>}

                {type === "cancelMeeting" && <p>{t("meeting_cancel")}</p>}

                {text && <p>{text}</p>}

                <button
                    onClick={type === "wantTalk" ? handleSubmitWithPsych : handleSubmit}
                    className="send"
                    disabled={needPsychSelection && !selectedPsych}
                    style={needPsychSelection && !selectedPsych ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                >
                    {submitText || t("send_button")}
                </button>

                <button onClick={handleClose} className="close">
                    <img alt="" src={close} />
                </button>
            </div>
        </div>
    );
};
